import {
  Directive,
  Input,
  HostBinding
} from '@angular/core';


@Directive({
  selector: '[tabButton]',
  exportAs: 'tab-button'
})
export class TabButtonDirective {
  @HostBinding('class.tab-btn') btnClass: boolean = true;
  @HostBinding('class.active')
  @Input()
  active: boolean = false;

  @Input() name: string;
}
